export default __webpack_public_path__ + "static/media/digital.fcea5b6f.png";